import React, { useState } from 'react';
import { Dialog } from '@material-ui/core';
import CloseButton from '../../Utilities/CloseButton';

interface ImageModel {
    id: number;
    added_at: string;
    content: string;
    image: string;
    last_updated: string;
    profile_picture: false;
    title: string;
    url: string;
    user: number;
}
export default function Image({ content }: { content: ImageModel }) {
    const [modelOpen, setModelOpen] = useState(false);
    return (
        <>
            <div style={{ maxWidth: 300, paddingTop: 20 }} onClick={() => setModelOpen(true)}>
                <img src={content.image} alt="" width="100%" />
            </div>

            <Dialog
                fullWidth
                maxWidth="md"
                open={modelOpen}
                onClose={() => {
                    setModelOpen(false);
                }}
                aria-labelledby="max-width-dialog-title"
            >
                <div style={{ position: 'relative' }}>
                    <div style={{ position: 'absolute', top: 5, right: 5 }}>
                        <CloseButton onClose={() => setModelOpen(false)} />
                    </div>
                    <img src={content.image} alt="" width="100%" />
                </div>
            </Dialog>
        </>
    );
}
